const vueAppMagenotApiUrl = import.meta.env.VITE_APP_MAGENTO_API_URL;
import { wrapGqlRequest } from "@/services/graphqlEndPointCommonSetting/wrapGqlRequest";

export const registrationService = {
    doResetPassword,
    doConfirmEmail,
    doSignUp,
    doForgotPassword
};
//function handleResponse(response, retryFunction){
function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        } else {
            return data;
        }
    });
}

function doResetPassword(resetOne) { //userId, newPassword, token
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ "email": resetOne.email, "resetToken": resetOne.token, "newPassword": resetOne.newPassword })
    };
    return fetch(`${vueAppMagenotApiUrl}/rest/V1/customers/resetPassword`, requestOptions).then(handleResponse);
}

function doForgotPassword(forgot) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
            "email": forgot.email,
            "template": "email_reset",
            "websiteId": 1
        })
    };

    return fetch(`${vueAppMagenotApiUrl}/rest/V1/customers/password`, requestOptions).then(handleResponse);
}
//async function doconfirmEmail(token) {
async function doConfirmEmail() {
    let details = {
        "massages": 'Your Email id confirm Please login In',
        "response": "400"
    }
    return details;
}

/*function doSignUp(registration) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
            "customer": {
                "email": registration.email,
                "firstname": registration.firstname,
                "lastname": registration.lastname
            },
            "password": registration.password,
            "mask_id":vueAppMaskId
            
        })

    };

    // console.log(registration);

    return fetch(`${vueAppMagenotApiUrl}/rest/all/V1/register-customers`, requestOptions).then(handleResponse);
}*/
async function doSignUp(registration) {

    const query = `
    mutation CreateCustomer($input: CustomerCreateInput!) {
  createCustomerV2(input: $input) {
    customer {
      email
      firstname
      lastname
      created_at
      date_of_birth
      default_billing
      default_shipping
      allow_remote_shopping_assistance
      is_subscribed
      job_title
      gender
      group {
        uid
      }
      custom_attributes(attributeCodes: [""]) {
        code
        ... on AttributeValue {
          code
          value
        }
        ... on AttributeSelectedOptions {
          selected_options {
            value
            label
          }
        }
      }
      addresses {
        firstname
        lastname
        street
        city
        postcode
        country_code
        region_id
        region {
          region
          region_code
          region_id
        }
        custom_attributesV2 {
          code
          ... on AttributeValue {
            code
            value
          }
          ... on AttributeSelectedOptions {
            selected_options {
              value
              label
            }
          }
        }
      }

      addressesV2(currentPage: 1, pageSize: 5) {
        items {
          firstname
          lastname
          street
          city
          postcode
          country_code
          region_id
          region {
            region
            region_code
            region_id
          }
          custom_attributesV2 {
            code
            ... on AttributeValue {
              code
              value
            }
            ... on AttributeSelectedOptions {
              selected_options {
                value
                label
              }
            }
          }
        }
      }
    }
  }
}
  `;
    const variables = {
        input: {
            email: `${registration?.email}`,
            firstname: `${registration?.firstname}`,
            lastname: `${registration?.lastname}`,
            password: `${registration?.password}`,
        },
    };

    const data = await wrapGqlRequest(query, variables, "createCustomerV2");
    return data?.customer || null;
}
export const doUpdateSubscription = (one) => {
    // const requestOptions = {
    //     method: 'PUT',
    //     headers: {
    //         'Content-type': 'application/json',
    //         ...authHeader()
    //     },
    //     body: JSON.stringify({
    //         "customer": {
    //             "firstname": one.firstname,
    //             "lastname": one.lastname,
    //             "email": one.email,
    //             "website_id": one.website_id,
    //             "extension_attributes": {
    //                 "is_subscribed": true
    //             }
    //         }
    //     })
    // };
    // return fetch(`${vueAppMagenotApiUrl}/rest/V1/customers/me`, requestOptions)
    const updateCustomerV2Mutation = `mutation {
  updateCustomerV2(input: {
    is_subscribed: true
  }) {
      customer {
        date_of_birth
        default_billing
      default_shipping
        email
        firstname
        gender
        is_subscribed
        job_title
        lastname
        middlename
        prefix
      }
    }
  }`;
    return wrapGqlRequest(updateCustomerV2Mutation, {}, "updateCustomerV2");
};
